var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { translate, useToastService } from '@lucidlink/uicore';
import { useDrawer, useLucidSdk } from '#context';
export const useOpenGuestDetailsDrawer = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { openDrawer } = useDrawer();
    const { addToast } = useToastService();
    return useMutation({
        mutationFn: (email) => lucidSdk
            .workspaceClient(workspaceId)
            .encryptStringWithWorkspaceCommonKey(email, { urlSafe: true }),
        onSuccess: (eGuestEmail) => {
            openDrawer({
                type: 'guestDetails',
                eGuestEmail,
                filespaceId,
                workspaceId,
            });
        },
        onError: () => {
            addToast({
                content: {
                    message: translate('Unable to open guest details. Please try again.'),
                },
                kind: 'negative',
                hasCloseButton: true,
                'data-testid': 'error-open-guest-details',
            });
        },
    });
};
_react_refresh_temp_1(useOpenGuestDetailsDrawer, "Ixbr15/DqfCf3QS5uTqIcKX2Z40=", false, () => [useLucidSdk, useDrawer, useToastService, useMutation]);
